export default __webpack_public_path__ + "static/media/ic_aave_40.af7e71d9.svg";